import React, { useState, useEffect } from "react";

import ThemeContext, { initialThemeState } from "./ThemeContext";

const ThemeProvider = ({ children }) => {
  const [themeClass, setThemeClass] = useState(initialThemeState.theme);
  const themeInverse = { dark: "light", light: "dark" };
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener(
      "change",
      () =>
        localStorage.getItem("globalTheme") === "system" && setTheme("system")
    );

  useEffect(() => {
    const savedThemeLocal = localStorage.getItem("globalTheme");
    savedThemeLocal && setTheme(savedThemeLocal);
  }, []);

  const setTheme = theme => {
    if (window.matchMedia && theme === "system") {
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? setClass("dark")
        : setClass("light");
    } else {
      setClass(theme);
    }
    setThemeClass(theme);
    localStorage.setItem("globalTheme", theme);
  };

  const setClass = theme => {
    const bodyClass = document.body.classList;
    bodyClass.add(theme);
    bodyClass.remove(themeInverse[theme]);
  };

  return (
    <ThemeContext.Provider value={{ theme: themeClass, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
